export enum ProgressBarState {
  SUCCESS = 'success',
  NOTE = 'note',
  BRAND = 'brand',
  NEUTRAL = 'neutral'
};
